// src/SliderComponent.js
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Box from '@mui/joy/Box';
import '../styles/SliderComponent.css';
const SliderComponent = ({ images }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true, // Enable automatic sliding
    autoplaySpeed: 5000,
     // Set the speed to 2 seconds (2000 ms)
  };

  return (
    <Box sx={{ width: {xs: '240px',sm: '300px', md:'600px'}, margin: '0 auto', padding: '20px 20px 20px 0px' }}>
      <Slider  {...settings}>
        {images.map((image, index) => (
          <Box key={index}>
            <img src={image} alt={`Slide ${index + 1}`} style={{ width: '100%' }} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default SliderComponent;
